module.exports = __webpack_public_path__ + "img/1-2-IMG_3001.6b2e192c.png";